<script>
  // A tab strip for a screen that does several separable jobs. Only the strip —
  // the caller keeps the panels and decides how to hide them, because the right
  // answer differs: a facet holding a half-built draft must be hidden rather
  // than unmounted, and only the caller knows which of its facets those are.
  //
  // `facets` is [{ id, label }]. Order is the caller's; nothing here sorts.
  let { facets = [], active = null, onselect } = $props();
</script>

<div class="facets" role="tablist">
  {#each facets as f}
    <button
      class="facet" class:active={f.id === active}
      role="tab" aria-selected={f.id === active}
      onclick={() => onselect(f.id)}
    >{f.label}</button>
  {/each}
</div>

<style>
  .facets {
    display: flex;
    gap: var(--space-3);
    border-bottom: 1px solid var(--border);
    margin-bottom: var(--space-4);
    /* Three labels fit narrow; more would not, and a tab strip that wraps into
       two rows stops reading as one control. */
    overflow-x: auto;
  }
  .facet {
    background: none;
    border: none;
    border-bottom: 2px solid transparent;
    padding: var(--space-2) 0;
    margin-bottom: -1px;
    font: inherit;
    color: var(--muted, inherit);
    white-space: nowrap;
    cursor: pointer;
  }
  .facet:hover { color: inherit; }
  .facet.active {
    color: inherit;
    border-bottom-color: var(--accent);
    font-weight: 600;
  }
</style>
